export default "__VITE_ASSET__uaxlBunrFDLjkqVnXBuE4A__"